export default {
    SET_ORDERS: (state, payload) => {
        state.orders = payload;
    },
    SET_ORDERS_FILTROS: (state, payload) => {
        state.ordersFiltros = payload;
    }
}